/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProfileAdminLinks
 */
export interface ProfileAdminLinks {
    /**
     * 
     * @type {string}
     * @memberof ProfileAdminLinks
     */
    comatchPage?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAdminLinks
     */
    shakePage: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAdminLinks
     */
    dashboardPage: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAdminLinks
     */
    compliancePage: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAdminLinks
     */
    salesforcePage?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAdminLinks
     */
    downloadCv: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAdminLinks
     */
    editResume: string;
}

/**
 * Check if a given object implements the ProfileAdminLinks interface.
 */
export function instanceOfProfileAdminLinks(value: object): value is ProfileAdminLinks {
    if (!('shakePage' in value) || value['shakePage'] === undefined) return false;
    if (!('dashboardPage' in value) || value['dashboardPage'] === undefined) return false;
    if (!('compliancePage' in value) || value['compliancePage'] === undefined) return false;
    if (!('downloadCv' in value) || value['downloadCv'] === undefined) return false;
    if (!('editResume' in value) || value['editResume'] === undefined) return false;
    return true;
}

export function ProfileAdminLinksFromJSON(json: any): ProfileAdminLinks {
    return ProfileAdminLinksFromJSONTyped(json, false);
}

export function ProfileAdminLinksFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileAdminLinks {
    if (json == null) {
        return json;
    }
    return {
        
        'comatchPage': json['comatchPage'] == null ? undefined : json['comatchPage'],
        'shakePage': json['shakePage'],
        'dashboardPage': json['dashboardPage'],
        'compliancePage': json['compliancePage'],
        'salesforcePage': json['salesforcePage'] == null ? undefined : json['salesforcePage'],
        'downloadCv': json['downloadCv'],
        'editResume': json['editResume'],
    };
}

export function ProfileAdminLinksToJSON(value?: ProfileAdminLinks | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'comatchPage': value['comatchPage'],
        'shakePage': value['shakePage'],
        'dashboardPage': value['dashboardPage'],
        'compliancePage': value['compliancePage'],
        'salesforcePage': value['salesforcePage'],
        'downloadCv': value['downloadCv'],
        'editResume': value['editResume'],
    };
}

